module.exports = __webpack_public_path__ + "static/Banner-30-b9a1634697ff7676a4fdbdcf545c382e.png";